import { IConfigurationSection, ConfigurationSection } from '@/models/configuration/Section';
import { TableDataSetField, ITableDataSetField } from './TableDataSetField';
import { ConfigurationField } from '../configuration/Field';

export interface ITableDataSetSection extends IConfigurationSection {
    fields: TableDataSetField[];
}

export class TableDataSetSection extends ConfigurationSection {
    public fields: TableDataSetField[];

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ITableDataSetSection);
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfigurationSection);
    constructor(obj?: any) {
        super(obj);
        this.fields = [];
        if (obj && obj.fields !== undefined) {
            obj.fields.forEach((field: ConfigurationField | TableDataSetField) => {
                this.fields.push(new TableDataSetField(field));
            });
        }
    }
}
